import { ICrud } from "./common";

export enum EPushNotificationStatus {
  DRAFT = "DRAFT",
  SCHEDULED = "SCHEDULED",
  SENDING = "SENDING",
  SENT = "SENT",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

// Delivery stats attached to detail response for SENT/SENDING/FAILED blasts.
// `totalDeliveries` = number of devices (a user with 2 devices counts as 2).
export interface IPushNotificationStats {
  sent: number;
  failed: number;
  totalDeliveries: number;
}

export interface IPushNotification extends ICrud {
  title: string;
  body: string;
  deepLink?: string | null;
  imageUrl?: string | null;
  status: EPushNotificationStatus;
  scheduledAt?: string | null;
  sentAt?: string | null;
  createdBy?: string;
  stats?: IPushNotificationStats;
}

// Body for POST /push-blast/drafts and PATCH /push-blast/drafts/:id
export interface ICreatePushNotificationDTO {
  title: string;
  body: string;
  deepLink?: string;
  imageUrl?: string;
}

// Body for POST /push-blast/:id/schedule
export interface ISchedulePushNotificationDTO {
  scheduledAt: string; // ISO 8601, must be at least 1 minute in the future
}
